"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ProgressiveLive_exports = {};
__export(ProgressiveLive_exports, {
  default: () => ProgressiveLive_default
});
module.exports = __toCommonJS(ProgressiveLive_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M24.84 20C24.84 22.6731 22.6731 24.84 20 24.84C17.327 24.84 15.16 22.6731 15.16 20C15.16 17.3269 17.327 15.16 20 15.16C22.6731 15.16 24.84 17.3269 24.84 20Z",
      fill: "#D16D37"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 23.388C21.8712 23.388 23.388 21.8711 23.388 20C23.388 18.1289 21.8712 16.612 20 16.612C18.1289 16.612 16.612 18.1289 16.612 20C16.612 21.8711 18.1289 23.388 20 23.388ZM20 24.84C22.6731 24.84 24.84 22.6731 24.84 20C24.84 17.3269 22.6731 15.16 20 15.16C17.327 15.16 15.16 17.3269 15.16 20C15.16 22.6731 17.327 24.84 20 24.84Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M33.3474 6.65264C33.0639 6.36912 32.6042 6.36912 32.3207 6.65264C32.0371 6.93616 32.0371 7.39584 32.3207 7.67936C39.1251 14.4839 39.1251 25.5161 32.3207 32.3206C32.0371 32.6041 32.0371 33.0638 32.3207 33.3473C32.6042 33.6309 33.0639 33.6309 33.3474 33.3473C40.7189 25.9758 40.7189 14.0242 33.3474 6.65264Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.6794 7.67936C7.96292 7.39584 7.96292 6.93616 7.6794 6.65264C7.39587 6.36912 6.9362 6.36912 6.65268 6.65264C-0.718861 14.0242 -0.718861 25.9758 6.65268 33.3473C6.9362 33.6309 7.39587 33.6309 7.6794 33.3473C7.96292 33.0638 7.96292 32.6041 7.6794 32.3206C0.874901 25.5161 0.8749 14.4839 7.6794 7.67936Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M28.3784 11.6217C28.0949 11.3381 27.6352 11.3381 27.3517 11.6217C27.0682 11.9052 27.0682 12.3649 27.3517 12.6484C31.4119 16.7086 31.4119 23.2915 27.3517 27.3517C27.0682 27.6352 27.0682 28.0949 27.3517 28.3784C27.6352 28.662 28.0949 28.662 28.3784 28.3784C33.0057 23.7512 33.0057 16.2489 28.3784 11.6217Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.6484 12.6484C12.9319 12.3649 12.9319 11.9052 12.6484 11.6217C12.3648 11.3381 11.9052 11.3381 11.6216 11.6217C6.99438 16.2489 6.99438 23.7512 11.6216 28.3784C11.9052 28.662 12.3648 28.662 12.6484 28.3784C12.9319 28.0949 12.9319 27.6352 12.6484 27.3517C8.58814 23.2915 8.58814 16.7086 12.6484 12.6484Z",
      fill: "currentColor"
    }
  )
);
const SvgProgressiveLive = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ProgressiveLive_default = SvgProgressiveLive;
